import { get } from '../../../../infra/rest';
import { urlCreator } from '../../../../shared/utils/url-helpers';
import { GetAllCustomFields, CustomFields, GetPrimitiveCustomField, GetSingleSelectCustomField } from '../typings';

function getAllCustomFields(): Promise<GetAllCustomFields<CustomFields>>;
function getAllCustomFields(
  type: 'text' | 'number' | 'date' | 'boolean'
): Promise<GetAllCustomFields<GetPrimitiveCustomField>>;
function getAllCustomFields(type: 'single_select'): Promise<GetAllCustomFields<GetSingleSelectCustomField>>;
async function getAllCustomFields(
  type?: 'text' | 'number' | 'date' | 'single_select' | 'boolean'
): Promise<GetAllCustomFields<CustomFields>> {
  const url = urlCreator({
    baseUrl: '/v2/custom-fields',
    query: {
      type,
    },
  });

  return get<GetAllCustomFields<CustomFields>>(url, undefined, true);
}

export { getAllCustomFields };
